import ConfigSelector from './ConfigSelector';
import { PaginationListType } from '../../../Types/PaginationParams';
import { mcpService } from '../../../Services/mcpService';

interface McpConfig {
    identifier: string;
    title: string;
}

interface McpToolSelectorProps {
    mcpConfigs: McpConfig[];
    selectedTools: { identifier: string; identifierOfConfig: string }[];
    onToggleTool: (itemId: string, identifierOfConfig: string) => void;
    i18n: any;
}

function McpToolSelector({ mcpConfigs, selectedTools, onToggleTool, i18n }: McpToolSelectorProps) {
    const loadTools = async (
        configIdentifier: string,
        page: number,
        itemsPerPage: number,
        query: string | null = null,
    ) => {
        const response = await mcpService.getTools(configIdentifier, page, itemsPerPage, query);
        const tools = response.data.data || [];

        const items = tools.map((tool: any) => ({
            identifier: tool.identifier,
            title: tool.name,
            description: tool.description,
            config: { identifier: configIdentifier, title: '' },
        }));

        return {
            data: {
                data: items,
                total: response.data.total,
            },
        };
    };

    const getListType = (configIdentifier: string): PaginationListType => {
        return `McpTools_${configIdentifier}` as PaginationListType;
    };

    return (
        <ConfigSelector
            configs={mcpConfigs}
            selectedItems={selectedTools}
            onToggleItem={onToggleTool}
            i18n={i18n}
            itemsFunction={loadTools}
            getListType={getListType}
            placeholders={{
                search: i18n.translate({
                    id: 'search.tools',
                    sourceName: 'PromptFunction',
                }),
                empty: i18n.translate({
                    id: 'placeholder.mcpTools',
                    sourceName: 'PromptFunction',
                }),
            }}
        />
    );
}

export default McpToolSelector;
